import { Pipe, PipeTransform } from '@angular/core';

type birim = 'bayt' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB';
type kusuratBirimi = {
    [u in birim]: number;
};

const VarsayilanBirimler: kusuratBirimi = {
    bayt: 0,
    KB: 0,
    MB: 1,
    GB: 1,
    TB: 2,
    PB: 2
};

@Pipe({ name: 'toDosyaBoyutu', standalone: true })
export class DosyaBoyutuPipe implements PipeTransform {
    private readonly birimler: birim[] = ['bayt', 'KB', 'MB', 'GB', 'TB', 'PB'];

    transform(bayt: number = 0, kusurat: number | kusuratBirimi = VarsayilanBirimler): [number, string] {
        if (isNaN(parseFloat(String(bayt))) || !isFinite(bayt)) return [-1, '?'];

        let birimIndex = 0;

        while (bayt >= 1024) {
            bayt /= 1024;
            birimIndex++;
        }

        const unit = this.birimler[birimIndex];

        if (typeof kusurat === 'number') {
            return [parseFloat(bayt.toFixed(+ kusurat)), unit];// `${bayt.toFixed( + kusurat)} ${unit}`;
        }
        return [parseFloat(bayt.toFixed(kusurat[unit])), unit];//`${bayt.toFixed(kusurat[unit])} ${unit}`;
    }
}
/**
 * 
 */

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const FILE_SIZE_UNITS_LONG = ['Bytes', 'Kilobytes', 'Megabytes', 'Gigabytes', 'Pettabytes', 'Exabytes', 'Zettabytes', 'Yottabytes'];

@Pipe({
    name: 'formatFileSize',standalone:true
})
export class FormatFileSizePipe implements PipeTransform {
    transform(sizeInBytes: number, longForm: boolean): string {
        const units = longForm
            ? FILE_SIZE_UNITS_LONG
            : FILE_SIZE_UNITS;

        let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
        power = Math.min(power, units.length - 1);

        const size = sizeInBytes / Math.pow(1024, power); // size in new units
        const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
        const unit = units[power];

        return `${formattedSize} ${unit}`;
    }
}
